import React from 'react';
import PropTypes from 'prop-types';
import styles from './map-banner.module.scss';
import { humanizeNumber } from '../../helpers/formatters';
import closeIcon from '../../../public/img/close-icon.svg';

const factoids = [
  {
    label: 'people',
    key: 'population2018',
    svgFile: 'people-icon',
    format: (num) => humanizeNumber(num, 'number', true),
  },
  {
    label: 'median income',
    key: 'medianIncome2017',
    svgFile: 'income-icon',
    format: (num) => humanizeNumber(num, 'number'),
  },
  {
    label: 'median age',
    key: 'medianAge2018',
    svgFile: 'age-icon',
    format: (num) => num,
  },
];

const MapBanner = ({ council, children, comparing, onCloseClicked }) => {
  return (
    <div className={styles.mapBanner} data-comparing={comparing}>
      <button className={styles.closeButton} onClick={onCloseClicked}>
        <img src={closeIcon} alt="" />
      </button>
      <h2 className={styles.mapBannerHeading} data-comparing={comparing}>
        {council.name}
      </h2>
      <div className={styles.mapBannerDataRow} data-comparing={comparing}>
        {factoids.map((factoid, i) => {
          const { label, key, svgFile, format } = factoid;
          return (
            <div className={styles.mapBannerDataBlockWrapper} key={i}>
              <img
                src={`${process.env.PUBLIC_URL}/img/${svgFile}.svg`}
                alt={`${label} icon`}
                width="35"
                height="46"
              />
              <div className={styles.mapBannerDataBlockContent}>
                <div className={styles.mapBannerDataNumber}>
                  {format(council[key])}
                </div>
                <span>{label}</span>
              </div>
            </div>
          );
        })}
      </div>
      <div className={styles.mapBannerLegend}>
        <span> This demographic data was sourced from the</span>
        <a
          className={styles.externalLink}
          href="http://www.abs.gov.au/"
          rel="noopener noreferrer"
          target="_blank"
        >
          Australian Bureau of Statistics
        </a>
        <span>.</span>
      </div>
    </div>
  );
};

MapBanner.propTypes = {
  council: PropTypes.object,
};

export default MapBanner;



// WEBPACK FOOTER //
// ./src/components/council-map-container/map-banner.js